import React, { useEffect, useState } from "react";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Input from "../ui/Input";
import Divider from "../ui/Divider";
import { listen } from "../hooks/Listener";
import { KBD } from "../utils/Keybindings";
import { VALIDATE } from "../utils/Validators";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import { useGlobals } from "../hooks/Globals";

export default function SetupTaxCodesSearch(props) {

    const { controller = "", route = "", callback = () => { }, permission = false } = props;
  
    const [search, setSearch] = useState("");
  
    const actions = [
        { key: KBD.ESCAPE, action: () => { callback(false) } },
        { key: KBD.ENTER, action: () => { callback(search) } },
        { key: KBD.PAGE_DOWN, action: () => { callback(search) } },
    ]

    useEffect(() => { 
        const cleanup = listen(controller, route, actions, false, [KBD.ESCAPE, KBD.ENTER, KBD.PAGE_DOWN]);
        return cleanup;
    }, [actions, search])

      
    return (
        <>
            <div style={{ "width": "300px" }}>
                <div className="shim" /><div className="shim" />
                <Label style={{"textAlign" : "center"}} >Show tax codes with <span className="text-light">description</span> containing</Label>
                <div className="shim" /><div className="shim" />
                <Space height={25} size={10}>
                    <Label width={80}>Term</Label><Divider vertical />
                    <Input controlled={true} style={{"textAlign" : "left"}} onChange={(e) => setSearch(e)} autofocus autoselect placeholder="" width={150} edit value={search} />
                </Space>
            </div>
            {/* <small><pre>{JSON.stringify(signal.value, null, 2)}</pre></small> */}
        </>
    )
}